import SwiperCarousel from '../utils/swiper-carousel';

export default (element) => {
  const el = element.querySelector('[data-category-carousel]');
  const scrollbar = element.querySelector('[data-category-scrollbar]');

  if (!el) return;

  if (el && scrollbar) {
    const observer = new MutationObserver( (mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const scrollbarLockActive = scrollbar.classList.contains('swiper-scrollbar-lock');
          if (scrollbarLockActive) {
            el.classList.remove('lg:pb-7');
          } else {
            el.classList.add('lg:pb-7');
          }
        }
      });
    });
    observer.observe(scrollbar, { attributes: true });
    el.querySelector('.swiper-scrollbar').classList.remove('opacity-0');
  }

  const init = () => {
    // eslint-disable-next-line no-new
    new SwiperCarousel(el, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      allowTouchMove: true,
      navigation: {
        nextEl: '.category-button-next',
        prevEl: '.category-button-prev',
      },
      breakpoints: {
        1024: {
          spaceBetween: 10,
        },
      },
      scrollbar: {
        el: '.category-scrollbar',
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  };

  init();
};
